export const GET_TERMS_DATA = 'GET_TERMS_DATA'
export const SET_TERMS_DATA = 'SET_TERMS_DATA'
export const SET_TERMS_ERROR = 'SET_TERMS_ERROR'
export const SET_TERMS_PROCESSING = 'SET_TERMS_PROCESSING'

export function getTermsData (searchText, language, filterType) {
  return {
    type: GET_TERMS_DATA,
    payload: { searchText, language, filterType },
  }
}

export function setTermsData (data) {
  return {
    type: SET_TERMS_DATA,
    payload: { data },
  }
}

export function setTermsError (error) {
  return {
    type: SET_TERMS_ERROR,
    payload: { error },
  }
}

export function setTermsProcessing (processing = true) {
  return {
    type: SET_TERMS_PROCESSING,
    payload: { processing },
  }
}
